import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { CreateMembershipGroupCardTagFormSchemaValues as FormSchemeValues } from 'src/features/memberships/api/useCreateMembershipGroupCardTag';
import type { MembershipGroupCardTag } from 'src/features/memberships/types';
import type { GeneralSmartParkError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/tags/:membershipGroupCardTagId/';

interface DTO extends FormSchemeValues {
    parkingId: string;
    membershipGroupId: number;
    membershipGroupCardTagId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({
    parkingId,
    membershipGroupId,
    membershipGroupCardTagId,
    ...data
}: DTO): Promise<MembershipGroupCardTag> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipGroupId, membershipGroupCardTagId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_MEMBERSHIP_GROUP_CARD_TAG_RESOURCE, useMutationHook as useUpdateMembershipGroupCardTag };
export type {
    DTO as UpdateMembesrhipGroupCardTagDTO,
    FormSchemeValues as UpdateMembershipGroupCardTagFormSchemaValues,
};
